{
  "dss": {
    "button": {
      "back": "Atpakaļ",
      "cancel": "Atcelt",
      "close": "Aizvērt",
      "confirmDelete": "Jā, dzēst",
      "continue": "Turpināt",
      "logout": "Izrakstīties",
      "passwordReset": "Paroles atiestatīšana",
      "save": "Saglabāt",
      "verify": "Apstiprināt"
    },
    "error": {
      "403": "Jums nav piekļuves šai lapai.",
      "404": "Šī lapa neeksistē.",
      "generic": "Radās kļūda. Lūdzu, mēģiniet vēlāk vēlreiz.",
      "throttling": "Pārāk daudz mēģinājumu. Šī darbība uz laiku ir bloķēta.",
      "title": "Kļūda",
      "title403": "Piekļuve liegta",
      "title404": "Nav atrasts"
    },
    "footer": {
      "imprint": "Impressums",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Privātuma politika",
      "terms": "Noteikumi un nosacījumi"
    },
    "label": {
      "CRMAccountNumber": "CRM konta numurs",
      "contact": "Kontakti",
      "email": "E-pasts",
      "faq": "BUJ",
      "female": "Ms.",
      "firstname": "Vārds",
      "help": "Palīdzība",
      "language": "Valoda",
      "lastname": "Uzvārds",
      "male": "Mr.",
      "needHelp": "Nepieciešama palīdzība?",
      "newPassword": "Jauna parole",
      "newPassword2": "Apstipriniet jauno paroli",
      "oldPassword": "Pašreizējā parole",
      "organization": "Organizācija",
      "password": "Parole",
      "required": "obligāti",
      "salutation": "Uzruna",
      "select": "Lūdzu, izvēlieties"
    },
    "lang": {
      "de": "Vācu"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Apstiprināt reģistrāciju",
        "wait": "Lūdzu, uzgaidiet, līdz konta apstiprināšana ir pabeigta."
      },
      "otp": {
        "btnResend": "Nosūtīt apstiprinājuma kodu vēlreiz",
        "msg": {
          "invalidOTP": "Ievadītā vienreizējā parole nav derīga.",
          "resendFail": "Neizdevās vēlreiz nosūtīt kodu. Lūdzu, mēģiniet vēlāk vēlreiz."
        },
        "spamDetail": "Pārbaudiet iesūtni un surogātpasta mapi, vai nav e-pasta no STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Nesaņēmāt e-pastu?",
        "subtitle": "Lai turpinātu, jums jāapstiprina sava e-pasta adrese.",
        "title": "Apstipriniet savu lietotāja kontu",
        "txtVerifyMail": "Lūdzu, ievadiet jauno apstiprinājuma kodu, ko nosūtījām uz jūsu e-pasta adresi {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nav ko atjaunināt.",
          "updateError": "Neizdevās atjaunināt personas datus.",
          "updated": "Personas dati ir atjaunināti.",
          "userLoadErr": "Ielādējot lietotāja datus, radās kļūda. Lūdzu, mēģiniet vēlāk."
        },
        "secOrganization": "Organizācija",
        "secPersonal": "Personīgie",
        "secSettings": "Vēlamie iestatījumi",
        "title": "Personīgā informācija"
      },
      "postPwSet": {
        "info": "Tagad varat izmantot savu jauno paroli.",
        "link_name": "Turpināt uz pašapkalpošanos",
        "link_url": "/user/ui/",
        "title": "Jūsu parole ir mainīta"
      },
      "resetPW": {
        "title": "Atiestatiet savu paroli"
      },
      "security": {
        "2fa": {
          "availableMethods": "Pieejamās 2FA metodes:",
          "info": "Divu faktoru autentifikācija (2FA) ir drošības funkcija, kas pievieno papildu aizsardzības līmeni jūsu kontam. Tā prasa izmantot divas metodes pieteikšanās laikā, nevis tikai lietotājvārdu un paroli.",
          "method": {
            "email": "E-pasts",
            "emailDesc": "Saņemiet vienreizējos kodus e-pastā, lai pabeigtu autentifikācijas pieprasījumus.",
            "oath": {
              "add": {
                "button": "Reģistrēt autentifikācijas lietotni"
              }
            }
          }
        },
        "authenticator": "Autentifikācijas lietotne",
        "infoFederatedAccount": "Šo kontu pārvalda jūsu organizācijas identitātes nodrošinātājs, tāpēc paroli šeit nevar mainīt. Lai mainītu paroli, pierakstieties, izmantojot organizācijas pieteikšanās lapu, vai sazinieties ar IT administratoru.",
        "lastUse": "Pēdējo reizi izmantots: {0}.",
        "msg": {
          "invalidPassword": "Ievadīta nederīga pašreizējā parole.",
          "passwordAlreadyUsed": "Nav atļauts atkārtoti izmantot pēdējās 5 paroles.",
          "pwUpdateError": "Mēģinot mainīt paroli, radās kļūda.",
          "pwUpdated": "Parole ir mainīta."
        },
        "noDevice": "Nav konfigurēts",
        "oathAdd": {
          "appInfo": "Lai atvieglotu pieteikšanos STIHL, varat izmantot autentifikācijas lietotnes, piemēram, {0}, {1}, {2} u.c., lai ģenerētu vienreizējās paroles, kuras tiek izmantotas kā otrais faktors pieteikšanās laikā.<br/>Ja esat pazaudējis vai aizmirsis savu mobilo ierīci, jebkurā laikā varat izmantot e-pastā nosūtīto 2FA kodu.<br/><br/>Lūdzu, izpildiet tālāk sniegtos norādījumus, lai iestatītu savu autentifikācijas ierīci.",
          "badCode": "Nederīgs kods, lūdzu, mēģiniet vēlreiz.",
          "error": "Mēģinot reģistrēt autentifikācijas ierīci, radās kļūda.",
          "headScan": "1. Skenējiet QR kodu ar savu autentifikācijas lietotni",
          "headVerify": "2. Apstipriniet kodu",
          "infoKey": "iestatīšanas atslēga",
          "infoKeyTitle": "Jūsu divu faktoru noslēpums",
          "infoScanBottom": "Nevarat skenēt? Varat izmantot {0}, lai manuāli konfigurētu savu autentifikācijas lietotni.",
          "infoVerify": "Ievadiet kodu, ko ģenerē jūsu autentifikācijas lietotne.",
          "success": "Jūsu autentifikācijas ierīce ir reģistrēta. Tagad varat to izmantot pierakstīšanai.",
          "title": "Reģistrējiet savu divu faktoru autentifikācijas ierīci"
        },
        "oathDelete": {
          "error": "Mēģinot izdzēst autentifikācijas ierīci, radās kļūda.",
          "success": "Autentifikācijas ierīce ir izdzēsta."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey ir kriptogrāfisko atslēgu pāri (publiskā un privātā atslēga), ko glabā autentifikators, kuru kontrolējat jūs. Autentifikators var pierādīt, ka lietotājs ir klāt un ir pilnvarots izmantot passkey. Autentifikatori pierāda pilnvarojumu ar PIN, kodu, biometriskiem datiem vai ierīces paroli atkarībā no to iespējām un konfigurācijas. Autentifikatori var būt dažādi – iPhone vai Android ierīce, Windows Hello, FIDO2 aparatūras drošības atslēga vai paroļu pārvaldnieks.",
            "info2": "Kad piesakāties STIHL, izmantojot passkey, jūsu autentifikators izmanto publiskās atslēgas kriptogrāfiju, lai pierādītu jūsu identitāti STIHL, nekad nesūtot pašu passkey. Passkey ir piesaistīti tīmekļa vietnes domēnam, piemēram, stihl-sso.com, un tiem nepieciešams drošs savienojums, kas nozīmē, ka pārlūkprogramma atteiks autentifikāciju līdzīgā pikšķerēšanas vietnē. Šīs īpašības padara passkey ļoti izturīgus pret pikšķerēšanu un daudz grūtāk uzbrūkamus nekā SMS vai TOTP 2FA, kurus var uzķert.",
            "info3": "Ar mākoņpakalpojumu atbalstu passkey pakalpojumi ļauj sinhronizēt atslēgas starp ierīcēm (piemēram, Apple ierīcēm, Android ierīcēm vai paroļu pārvaldniekiem), lai tās varētu izmantot vairākās vietās un tās būtu grūtāk pazaudēt. Kad vienā ierīcē esat iestatījis sinhronizētu passkey, tas ir pieejams vairākās ierīcēs, kas izmanto to pašu pakalpojumu. Piemēram, ja reģistrējat passkey savā iCloud kontā, izmantojot MacBook Touch ID, pēc tam varat izmantot šo passkey ar seju, pirkstu nospiedumu, PIN vai ierīces paroli vairākās ierīcēs, kas saistītas ar to pašu iCloud kontu.",
            "title": "Par passkey"
          },
          "add": {
            "button": "Pievienot jaunu Passkey",
            "error": "Pievienojot jaunu passkey, radās kļūda.",
            "success": "Jauns passkey ir pievienots."
          },
          "delete": {
            "button": "Dzēst Passkey",
            "error": "Dzēšot šo passkey, radās kļūda.",
            "success": "Passkey ir izdzēsts."
          },
          "edit": {
            "error": "Saglabājot passkey nosaukumu, radās kļūda.",
            "name": "Passkey nosaukums",
            "success": "Passkey nosaukums ir atjaunināts.",
            "title": "Piešķiriet savam Passkey nosaukumu, lai to atšķirtu no citiem"
          },
          "info": "Passkey ir vienkārša un droša alternatīva parolēm, kas apstiprina jūsu identitāti, izmantojot pieskārienu, sejas atpazīšanu, ierīces paroli vai PIN.",
          "none": "Nav konfigurēts neviens Passkey.",
          "reallyDelete": "Vai tiešām vēlaties dzēst Passkey?",
          "registeredPasskeys": "Jūsu reģistrētie Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Vai tiešām vēlaties dzēst autentifikācijas ierīci?",
        "secMFA": "Divu faktoru autentifikācija",
        "secPwdChange": "Mainīt paroli",
        "title": "Drošība"
      },
      "setPW": {
        "acceptTC": "Lūdzu, apstipriniet mūsu {terms} un izlasiet mūsu {privacy}.",
        "killSSO": "Anulēt visas aktīvās sesijas",
        "msg": {
          "tokenExpired": "Paroles saites vai koda derīgums ir beidzies. Lūdzu, sekojiet saitei, lai atiestatītu savu paroli: {link}."
        },
        "privacy": "Datu privātuma politika",
        "terms": "Noteikumi un nosacījumi",
        "title": "Ievadiet jaunu paroli"
      }
    },
    "validations": {
      "hasDigit": "Jāsatur cipars(i)",
      "hasLowercase": "Jāsatur mazais burts(i)",
      "hasSpecial": "Jāsatur speciālās rakstzīmes: {chars}",
      "hasUppercase": "Jāsatur lielais burts(i)",
      "invalidCharacters": "Satur nederīgas rakstzīmes",
      "maxLength": "Atļauts maksimums {max} rakstzīmes",
      "minLength": "Nepieciešamas vismaz {min} rakstzīmes",
      "notSameAsEmail": "Pārāk līdzīgs e-pasta adresei",
      "onlyValidCharactersAllowed": "Atļauti tikai burti, cipari un atstarpes.",
      "required": "Obligāts lauks",
      "sameAsPassword": "Paroles nesakrīt",
      "tcAccepted": "Lūdzu, apstipriniet mūsu noteikumus un nosacījumus.",
      "validEmail": "Nederīga e-pasta adrese.",
      "validOTP": "Lūdzu, ievadiet apstiprinājuma kodu."
    }
  }
}
